import api from "src/apis/api"

// ── Fetch ────────────────────────────────────────────────────────────────────
export async function fetchLeads({ page = 1, per_page = 20, scope = "all", status = "", source = "", q = "", project_id = "" } = {}) {
  const params = new URLSearchParams()
  params.set("page", page)
  params.set("per_page", per_page)
  if (scope && scope !== "all") params.set("scope", scope)
  if (status)     params.set("status", status)
  if (source)     params.set("source", source)
  if (q)          params.set("q", q)
  if (project_id) params.set("project_id", project_id)

  const { data } = await api.get(`/api/v1/leads?${params}`)
  return data
}

// ── Scope tab counts ──────────────────────────────────────────────────────────
export async function fetchLeadCounts() {
  const { data } = await api.get("/api/v1/leads/counts")
  return data.counts // { all, my, team, unassigned, deleted, duplicate }
}

// ── Create ───────────────────────────────────────────────────────────────────
export async function createLead(payload) {
  const { data } = await api.post("/api/v1/leads", { lead: payload })
  return data
}

// ── Update ───────────────────────────────────────────────────────────────────
export async function updateLead(id, payload) {
  const { data } = await api.patch(`/api/v1/leads/${id}`, { lead: payload })
  return data
}

// ── Delete (soft) ────────────────────────────────────────────────────────────
export async function deleteLead(id) {
  const { data } = await api.delete(`/api/v1/leads/${id}`)
  return data
}

// ── Bulk import ──────────────────────────────────────────────────────────────
export async function importLeads(rows) {
  const { data } = await api.post("/api/v1/leads/import", { leads: rows })
  return data
}
